import { render } from "./FileLabelsList.vue?vue&type=template&id=58dad384"
import script from "./FileLabelsList.vue?vue&type=script&lang=js"
export * from "./FileLabelsList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__